import { fromJS } from 'immutable';
import { Field, Formik, Form } from 'formik';
import Close from '@material-ui/icons/Close';
import withStyles from '@material-ui/styles/withStyles';

import { Grid, IconButton, InputAdornment } from '@material-ui/core';

import { facilityTypeToString } from 'mappers';
import { FacilityType } from 'app/app.constants';
import AutoSaveFormik from 'app/components/form/formik/AutoSaveFormik';
import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';
import SelectTextFieldFormik from 'app/components/form/formik/SelectTextFieldFormik';
import { FacilityStatus } from 'features/facilities/facilities.constants';
import { facilityStatusToString } from 'features/facilities/facility.mappers';

export const Filters = {
  TEXT_SEARCH: 'textSearch',
  FACILITY_TYPE: 'type',
  OPERATOR: 'operator',
  ORGANIZATION_ID: 'organizationId',
  FACILITY_STATUS: 'status',
};

const shouldSubmit = ({ isValid }) => isValid;

const facilityTypes = fromJS(Object.values(FacilityType));

const statuses = fromJS(Object.values(FacilityStatus));

const FacilitiesFilter = ({ classes, onSubmit, operators, initialValues }) => (
  <Formik enableReinitialize onSubmit={onSubmit} initialValues={initialValues}>
    <Form>
      <AutoSaveFormik timeout={1000} shouldSubmit={shouldSubmit}>
        <Grid container className={classes.root}>
          <Grid container spacing={2} alignItems="center">
            <Grid item container xs spacing={2} wrap="nowrap">
              <Grid xs item>
                <Field name={Filters.TEXT_SEARCH}>
                  {({ form, ...formik }) => (
                    <TextFieldFormik
                      form={form}
                      margin="none"
                      label="Name"
                      placeholder="Search facilities..."
                      inputProps={{
                        maxLength: 100,
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              title="Remove"
                              onClick={() =>
                                form.setFieldValue(
                                  Filters.TEXT_SEARCH,
                                  initialValues[Filters.TEXT_SEARCH],
                                )
                              }
                            >
                              <Close fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      {...formik}
                    />
                  )}
                </Field>
              </Grid>
              <Grid xs item>
                <SelectTextFieldFormik
                  margin="none"
                  items={facilityTypes}
                  label="Facility type"
                  name={Filters.FACILITY_TYPE}
                  getItemName={facilityTypeToString}
                />
              </Grid>
              <Grid xs item>
                <SelectTextFieldFormik
                  margin="none"
                  label="Operator"
                  items={operators}
                  name={Filters.OPERATOR}
                />
              </Grid>
              <Grid xs item>
                <SelectTextFieldFormik
                  margin="none"
                  label="Status"
                  items={statuses}
                  name={Filters.FACILITY_STATUS}
                  getItemName={facilityStatusToString}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AutoSaveFormik>
    </Form>
  </Formik>
);

const styles = {
  root: {
    marginBottom: 15,
    paddingTop: 15,
  },
  leftIcon: {
    marginRight: 10,
  },
};

export default withStyles(styles)(FacilitiesFilter);
